import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SearchTextField } from "@/components/common/TextField/searchTextField";
import { SearchRecommendDialog } from "@/components/SearchRecommend/SearchRecommendDialog";
import { useSearchWithSearchDialog } from "@/components/Search/useSearchWithSearchTerms";
export const SearchRequestForm = (param)=>{
    let {} = param;
    const { openSearchDialog , recommendSearchTermList , currentSearchTerm , isOpenSearchDialog , closeSearchDialog , searchTermValue , onClearSearchTerm , onChangeSearchTerm , handleSelectedSubject , selectedSubject , onSubmitSearchTerm , onSelectRecommendSearchTerm  } = useSearchWithSearchDialog();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SearchTextField, {
                readOnly: true,
                onClickForm: openSearchDialog,
                placeholder: recommendSearchTermList.placeHolder,
                name: "keyword",
                value: currentSearchTerm
            }),
            /*#__PURE__*/ _jsx(SearchRecommendDialog, {
                isOpen: isOpenSearchDialog,
                onClose: closeSearchDialog,
                modalValue: searchTermValue,
                onClear: onClearSearchTerm,
                onChange: onChangeSearchTerm,
                currentSubject: selectedSubject,
                handleCurrentSubject: handleSelectedSubject,
                onSubmit: onSubmitSearchTerm,
                onClick: onSelectRecommendSearchTerm,
                recommendSearchTermList: recommendSearchTermList
            })
        ]
    });
};
